import React, { useEffect, useState } from 'react';
import { alert_error, alert_success } from "../../AppContext";
import { Cookies } from "../../index.js";
import axios from "axios";
import { useParams } from "react-router-dom";
import { ClipLoader, PulseLoader } from 'react-spinners';
import AdModal from '../../app_structure/AdModal';
import { useNavigate, Link, useLocation } from "react-router-dom";

const Offerwall = () => {
    const [iduser, setiduser] = useState(null); //None Kích thước mặc định
    const [username, setusername] = useState(null); //None Kích thước mặc định
    const [iframeHeight, setIframeHeight] = useState(null); //None Kích thước mặc định\
    const iframeId = 'iframeContainer'; // Đặt id cho phần tử div
    const { slug_2 } = useParams();
    useEffect(() => {
        const divElement = document.getElementById(iframeId);

        // Nếu phần tử không tồn tại, hãy tạo nó
        if (!divElement) {
            const newDiv = document.createElement('div');
            newDiv.id = iframeId;
            document.body.appendChild(newDiv);
        }

        // Cập nhật kích thước iframe
        const divTop = document.getElementById(iframeId).getBoundingClientRect().top;
        const windowHeight = window.innerHeight * 1.05;
        const newHeight = `${windowHeight - divTop}px`;
        console.log(newHeight);
        setIframeHeight(newHeight);
        laydulieu();
    }, []); // Chạy useEffect chỉ một lần sau khi component mount
    function laydulieu() {
        const myCookieValue = Cookies.get('apikey');
        console.log(myCookieValue);
        axios.get('https://hust.media/jop/offerwall/getidusers.php?api_key=' + myCookieValue + '&service=' + slug_2)
            .then(response => {
                if (response.data.status) {
                    testFunction(response);
                }
                else {
                    alert_error('Đã xảy ra lỗi máy chủ vui lòng liên hệ admin');
                }
            })
            .catch(error => {
                alert_error('Đã xảy ra lỗi liên hệ admin mã lỗi ' + error );
            });
    };
    const navigate = useNavigate();
    function switch_router(link) {
        navigate(link);
    };
    function testFunction(response) {
        const info = response.data;
        const status = info.status;
        const message = info.message;
        const dulieu = info.data;
        if (status == 0) {
            alert_error(message);
        }
        else if (status == 1) {
            setiduser(dulieu.iduser);
            setusername(dulieu.username);
            alert_success(message);
        }
        if (info.redirect != null && info.redirect != '') {
            setTimeout(function () {
                // Chuyển hướng sang trang web khác
                switch_router(info.redirect);
            }, 200);
        }
    };
    const [showAd, setShowAd] = useState(true);
    const handleCloseAd = () => {
        setShowAd(false);
    };
    return (
        <>
            <AdModal isOpen={showAd} onClose={handleCloseAd} />
            <div id={iframeId} >    </div>
            {!iduser ? (<>
                <div style={{ textAlign: "center" }} className="mt-4 justify-center items-center">

                    <ClipLoader color="#fff" size={150} />
                </div>
            </>) : (<>
                {slug_2 == 'bitcotasks' ? (<>    
                <iframe
                    src={`https://bitcotasks.com//offerwall/6mqmstck5bzkomb37c7rpg0f16t9or/user` + iduser}
                    width="100%"
                    height={iframeHeight}
                    scrolling="yes"
                    frameBorder="0"
                    allowFullScreen
                ></iframe> </>) : (slug_2 == 'cpx_research' ? (<>
                    <iframe width="100%" scrolling="yes"
                        frameBorder="0" height={iframeHeight}
                        src={`https://offers.cpx-research.com/index.php?app_id=21777&ext_user_id=` + iduser + `&username=` + username + `&subid_1=123`}></iframe>

                </>) : (slug_2 == 'bitlabs' ? (<>
                    <iframe width="100%" scrolling="yes"
                        frameBorder="0" height={iframeHeight}
                        src={`https://web.bitlabs.ai/?uid=` + iduser + `&token=13273dbd-bce4-4df3-a895-01e92f777106&display_mode=offers,games`}></iframe></>)
                    : (slug_2 == 'adscend' ? (<>
                        <iframe width="100%" scrolling="yes"
                            frameBorder="0" height={iframeHeight}
                            src={`https://asmwall.com/adwall/publisher/116285/profile/19558?subid1=` + iduser}></iframe></>)
                        : slug_2 == 'timewall' ? (<>
                            <div className="flex items-center justify-center mt-14">
                                <a
                                    href={'https://timewall.io/users/login?oid=98f8206afe7e1479&uid=' + iduser}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="relative inline-block overflow-hidden"
                                >
                                    <button className="relative z-10 px-10 py-4 bg-gradient-to-r from-blue-500 to-indigo-500 text-white rounded-full transition duration-300 transform hover:scale-105">
                                        <div className="text-xl">
                                            Làm ngay
                                        </div>
                                    </button>
                                    <div className="absolute top-0 left-0 w-full h-full bg-blue-500 opacity-50"></div>
                                    <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-blue-500 to-indigo-500 mix-blend-multiply"></div>
                                </a>
                            </div>
                        </>) : null)))}
            </>)
            }

        </>

    );
};

export default Offerwall;
